import { useEffect } from "react";
interface SvgSpriteProps {
  spritePath: string;
}

export const SvgSprite = ({ spritePath }: SvgSpriteProps) => {
  useEffect(() => {
    if (!spritePath) return;
    void fetch(spritePath, {
      credentials: "include",
      mode: "no-cors",
    })
      .then(response => response.text())
      .then(text => {
        const spriteElement = document.getElementById("react-icon-svg-sprite");
        if (!spriteElement) {
          const svg = document.createElement("svg");
          svg.id = "react-icon-svg-sprite";
          svg.innerHTML = text;
          document.body.appendChild(svg);
        }
      });
  }, [spritePath]);

  return null;
};
